import { Validators } from '@angular/forms';

export enum InvoiceTypeOfSupply {
  Commercial = 'Invoice',
  NonCommercial = 'ProformaInvoice',
}

export const InvoiceTypeValidators = [Validators.required];

export const InvoiceTypeErrors = {
  required: 'Це поле обов\'язкове',
}

export const InvoiceTypeOfSupplyTranslation: Record<InvoiceTypeOfSupply, string> = {
  [InvoiceTypeOfSupply.Commercial]: 'Комерційна поставка',
  [InvoiceTypeOfSupply.NonCommercial]: 'На безоплатній основі',
};

export const InvoiceTypeOfSupplyTransliteration: Record<InvoiceTypeOfSupply, string> = {
  [InvoiceTypeOfSupply.Commercial]: 'Commercial supply',
  [InvoiceTypeOfSupply.NonCommercial]: 'Non-commercial supply',
};

